export const translationsUz = {
  welcome: "Admin sahifasiga xush kelibsiz!",
  Navbar: {
    Register: "Roʻyxatdan oʻtish",
    Login: "Kirish",
  },
  SiteMode: {
    Dark: "Tun",
    Light: "Kun",
  },
  SideBarBtns: {
    Collections: "To'plamlar",
    Mycollection: "Mening To'plamlarim",
    CreateCollection: "To'plamlar yaratish",
    Users: "Foydalanuvchilar",
  },
  Search: {
    placeholder: "Qidirish...",
    search: "Qidirish",
  },
  NoItem: "To'plamda hali narsa yo'q!",
  NoCollection: "Sizda hali to‘plamlar yo‘q. Yaratish",
  ItemSectionTitle: "To'plamlar",
  UserPermission: "Sizga ruxsat berilmagan. Roʻyxatdan oʻting",
  ClickToRegister: "bu yerda",
  SuccessMsg: "Muvaffaqiyatli yangilandi",
  CollectionModal: {
    Title: "To'plam yaratish",
    Name: "Nomi",
    Markdown: "Markdown-ni qo'llab-quvvatlash",
    Description: "Tavsif",
    Topic: "Mavzu",
    UploadImg: "Rasm yuklash",
    AddCustomField: "Maxsus maydon qo'shing",
    Create: "Yaratish",
    SuccessMsgCustomField: "Muvaffaqiyatli qo'shildi",
    SuccessMsgCreate: "To'plam muvaffaqiyatli yaratildi",
  },
  CollectionBtn: {
    View: "Ko'rish",
    Delete: "O'chirish",
  },
  ItemModal: {
    Title: "Element yaratish",
    Name: "Nomi",
    EnterTag: "Tegni kiriting",
    UploadImg: "Rasm yuklash",
    Create: "Yaratish",
    SuccessMsg: "Element muvaffaqiyatli yaratildi",
  },
  ItemBtn: {
    View: "Ko'rish",
    Delete: "O'chirish",
  },
  UserRegistration: {
    Title: "Akkaunt yaratish",
    Username: "Foydalanuvchi nomi",
    Email: "Email",
    Password: "Parol",
    Signup: "Ro'yxatdan o'tish",
    Login: "Kirish",
    OrContinueWith: "Yoki davom eting",
    HaveAccount: "Akkaunt bormi?",
    ExistErrorMsg: "Bu emailga ega foydalanuvchi allaqachon mavjud!",
    SuccessMsg: "Muvaffaqiyatli ro'yxatdan o'tdi! Bir soniya kuting!",
    SuccessMsgForlogin: "Muvaffaqiyatli tizimga kirildi",
    NotFoundMsg: "Ushbu e-pochtaga ega foydalanuvchi topilmadi",
    BlockedMsg: "Foydalanuvchi hisobi bloklandi. Siz tizimga kira olmaysiz!",
    ServerMsg: "Server tomonida juda yomon narsa yuz berdi",
    AllFieldsMsg: "Barcha maydonlarni toʻldirish talab qilinadi"
  }
};
